import React from 'react'
import moment from 'moment-timezone'

// Registers the <add-to-calendar-button> custom element. The `no-pro`
// entrypoint drops the paid RSVP/hosted-ics code we don't use. This subpath
// only resolves because of the webpack/jest config aliases below — neither
// tool's resolver understands the package's package.json `exports` map.
import 'add-to-calendar-button/no-pro'

import css from './style.scss'

// Matches the site's orange accent and strips the library's default button
// chrome so it reads as a plain text link, like its date/time siblings.
// `--btn-underline` is the library's own hover fill — turned off here since
// we draw our own underline in style.scss instead.
const CALENDAR_BUTTON_STYLE = `
  --btn-background: transparent;
  --btn-hover-background: transparent;
  --btn-underline: transparent;
  --btn-border: none;
  --btn-hover-border: none;
  --btn-shadow: none;
  --btn-hover-shadow: none;
  --btn-active-shadow: none;
  --btn-text: rgba(176, 96, 0, 1);
  --btn-hover-text: rgba(176, 96, 0, 1);
  --btn-padding-x: 0;
  --btn-padding-y: 0;
`

/**
 * Text-styled "Add to Calendar" link, shared by anywhere a webinar's
 * date/time is shown. Reused as-is so the events list, the calendar and the
 * webinar detail page all offer the exact same calendar options.
 */
const AddToCalendarButton = ({ name, description, startAt, endAt, className }) => {
  const start = moment(startAt)
  const end = moment(endAt)

  return (
    <span className={[css.wrapper, className].filter(Boolean).join(' ')}>
      <add-to-calendar-button
        name={name}
        description={description}
        startDate={start.format('YYYY-MM-DD')}
        endDate={end.format('YYYY-MM-DD')}
        startTime={start.format('HH:mm')}
        endTime={end.format('HH:mm')}
        timeZone={moment.tz.guess()}
        options="['Google','Apple','Outlook.com','Yahoo','iCal']"
        hideCheckmark
        buttonStyle='text'
        trigger='click'
        size='2'
        styleLight={CALENDAR_BUTTON_STYLE}
      />
    </span>
  )
}

AddToCalendarButton.propTypes = {
  name: React.PropTypes.string.isRequired,
  description: React.PropTypes.string,
  startAt: React.PropTypes.string.isRequired,
  endAt: React.PropTypes.string.isRequired,
  className: React.PropTypes.string
}

export default AddToCalendarButton
